import React from 'react';
import { Analytics } from '@gik/core/utils';

// TODO: remove this after SPA migration - redirects will not interrupt events
export const fireCompletedPurchaseLocalStorageKey = 'gik-fire-completed-purchase';

// TODO: remove this after SPA migration - redirects will not interrupt events
export default function useCompletedPurchaseForPageAnalytics(): void {
  React.useEffect(() => {
    if (localStorage.getItem(fireCompletedPurchaseLocalStorageKey)) {
      localStorage.removeItem(fireCompletedPurchaseLocalStorageKey);
      Analytics.fireEvent('CompletedPurchaseCloseModal', {});
    }
  }, []);
}
